import DiscoverPanel from "./discover.js"

export default DiscoverPanel
